module.exports = __webpack_public_path__ + "static/img/test1.3cb8c064.jpg";